// import React, { useState, useEffect } from "react";
// import "./RegForm.css";
// import { useNavigate } from "react-router-dom";

// export default function RegistrationForm() {
//   const navigate = useNavigate();
//   const [message, setMessage] = useState({ type: "", text: "" });

//   const [form, setForm] = useState({
//     uid: "",
//     firstName: "",
//     gender: "",
//     company: "",
//     department: "",
//     addressType: "",
//     fullAddress: "",
//     city: "",
//     mealsPreferred: "",
//     postalCode: "",
//     state: "",
//     country: "",
//     gstNo: "",
//     email: "",
//     homePhone: "",
//     workPhone: "",
//     mobileNumber: "",
//     courses: [],
//     isMember: "",
//     memberNumber: "",
//     prevCertNo: "",
//     prevCertValidity: "",
//     agreement: false,
//   });

//   // Pre-fill from localStorage
//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     if (user) {
//       setForm((prev) => ({
//         ...prev,
//         uid: user.uid || "",
//         firstName: user.fname || user.displayName || "",
//         email: user.email || "",
//         mobileNumber: user.cNumber || "",
//       }));
//     }
//   }, []);

//   // Handle field changes
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     if (type === "checkbox" && name === "courses") {
//       setForm((prev) => ({
//         ...prev,
//         courses: checked
//           ? [...prev.courses, value]
//           : prev.courses.filter((course) => course !== value),
//       }));
//     } else if (type === "checkbox") {
//       setForm((prev) => ({
//         ...prev,
//         [name]: checked,
//       }));
//     } else {
//       setForm((prev) => ({
//         ...prev,
//         [name]: value,
//       }));
//     }
//   };

//   // Submit form
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     console.log("Form Data:", form);

//     try {
//       const res = await fetch("https://agepcoatings.com/registerprofile", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });
//       const data = await res.json();

//       if (data.success) {
//         setMessage({ type: "success", text: "✅ Profile updated successfully!" });
//         setTimeout(() => navigate("/profile"), 2000);
//       } else {
//         setMessage({ type: "error", text: "❌ Already Register Course." });
//       }
//     } catch (error) {
//       console.error("Error submitting form:", error);
//       setMessage({ type: "error", text: "❌ Server error, please try again." });
//     }
//   };

//   // Check if Level 2 or 3 selected
//   const needsPrevCert =
//     form.courses.some((c) => c.includes("Level 2")) ||
//     form.courses.some((c) => c.includes("Level 3"));

//   return (
//     <div className="container form-container mb-5">
//       <h2 className="text-center mb-4">Complete Your Profile</h2>

//       {message.text && (
//         <div
//           className={`alert ${
//             message.type === "success" ? "alert-success" : "alert-danger"
//           }`}
//           role="alert"
//         >
//           {message.text}
//         </div>
//       )}

//       <form onSubmit={handleSubmit}>
//         {/* Personal Details */}
//         <h5 className="section-title">Personal Details</h5>
//         <div className="row g-3">
//           {/* First Name */}
//           <div className="col-md-6">
//             <input
//               type="text"
//               name="firstName"
//               placeholder="First Name"
//               className="form-control"
//               onChange={handleChange}
//               value={form.firstName}
//             />
//           </div>
//           {/* Company */}
//           <div className="col-md-6">
//             <input
//               type="text"
//               name="company"
//               placeholder="Company"
//               className="form-control"
//               onChange={handleChange}
//               value={form.company}
//             />
//           </div>
//           {/* Gender */}
//           <div className="col-md-6 d-flex align-items-center">
//             <label className="me-3">Gender:</label>
//             <div className="form-check me-3">
//               <input
//                 className="form-check-input"
//                 type="radio"
//                 name="gender"
//                 value="Male"
//                 checked={form.gender === "Male"}
//                 onChange={handleChange}
//               />
//               <label className="form-check-label">Male</label>
//             </div>
//             <div className="form-check">
//               <input
//                 className="form-check-input"
//                 type="radio"
//                 name="gender"
//                 value="Female"
//                 checked={form.gender === "Female"}
//                 onChange={handleChange}
//               />
//               <label className="form-check-label">Female</label>
//             </div>
//           </div>
//           {/* Address Type */}
//           <div className="col-md-6 d-flex align-items-center">
//             <label className="me-3">Address:</label>
//             <div className="form-check me-3">
//               <input
//                 className="form-check-input"
//                 type="radio"
//                 name="addressType"
//                 value="Office"
//                 checked={form.addressType === "Office"}
//                 onChange={handleChange}
//               />
//               <label className="form-check-label">Office</label>
//             </div>
//             <div className="form-check">
//               <input
//                 className="form-check-input"
//                 type="radio"
//                 name="addressType"
//                 value="Residence"
//                 checked={form.addressType === "Residence"}
//                 onChange={handleChange}
//               />
//               <label className="form-check-label">Residence</label>
//             </div>
//           </div>
//           {/* Department */}
//           <div className="col-md-6">
//             <input
//               type="text"
//               name="department"
//               placeholder="Department"
//               className="form-control"
//               onChange={handleChange}
//               value={form.department}
//             />
//           </div>
//           {/* Full Address */}
//           <div className="col-md-6">
//             <input
//               type="text"
//               name="fullAddress"
//               placeholder="Full Address"
//               className="form-control"
//               onChange={handleChange}
//               value={form.fullAddress}
//             />
//           </div>
//           {/* City */}
//           <div className="col-md-6">
//             <input
//               type="text"
//               name="city"
//               placeholder="City"
//               className="form-control"
//               onChange={handleChange}
//               value={form.city}
//             />
//           </div>
//           {/* Postal / State / Country */}
//           <div className="col-md-4">
//             <input
//               type="text"
//               name="postalCode"
//               placeholder="Postal Code"
//               className="form-control"
//               onChange={handleChange}
//               value={form.postalCode}
//             />
//           </div>
//           <div className="col-md-4">
//             <input
//               type="text"
//               name="state"
//               placeholder="State"
//               className="form-control"
//               onChange={handleChange}
//               value={form.state}
//             />
//           </div>
//           <div className="col-md-4">
//             <input
//               type="text"
//               name="country"
//               placeholder="Country"
//               className="form-control"
//               onChange={handleChange}
//               value={form.country}
//             />
//           </div>
//           {/* GST */}
//           <div className="col-md-6">
//             <input
//               type="text"
//               name="gstNo"
//               placeholder="GST No"
//               className="form-control"
//               onChange={handleChange}
//               value={form.gstNo}
//             />
//           </div>
//           {/* Meals */}
//           <div className="col-md-6 d-flex align-items-center">
//             <label className="me-4">Meals Preferred:</label>
//             <div className="form-check me-3">
//               <input
//                 className="form-check-input"
//                 type="radio"
//                 name="mealsPreferred"
//                 value="Veg"
//                 checked={form.mealsPreferred === "Veg"}
//                 onChange={handleChange}
//               />
//               <label className="form-check-label">Veg</label>
//             </div>
//             <div className="form-check">
//               <input
//                 className="form-check-input"
//                 type="radio"
//                 name="mealsPreferred"
//                 value="Non-Veg"
//                 checked={form.mealsPreferred === "Non-Veg"}
//                 onChange={handleChange}
//               />
//               <label className="form-check-label">Non-Veg</label>
//             </div>
//           </div>
//         </div>

//         {/* Contact Details */}
//         <h5 className="section-title mt-4">Contact Details</h5>
//         <div className="row g-3">
//           <div className="col-md-6">
//             <input
//               type="email"
//               name="email"
//               placeholder="Email ID"
//               className="form-control"
//               onChange={handleChange}
//               value={form.email}
//             />
//           </div>
//           <div className="col-md-6">
//             <input
//               type="text"
//               name="homePhone"
//               placeholder="Home Phone"
//               className="form-control"
//               onChange={handleChange}
//               value={form.homePhone}
//             />
//           </div>
//           <div className="col-md-6">
//             <input
//               type="text"
//               name="workPhone"
//               placeholder="Work Phone"
//               className="form-control"
//               onChange={handleChange}
//               value={form.workPhone}
//             />
//           </div>
//           <div className="col-md-6">
//             <input
//               type="text"
//               name="mobileNumber"
//               placeholder="Mobile Number"
//               className="form-control"
//               onChange={handleChange}
//               value={form.mobileNumber}
//             />
//           </div>
//         </div>

//         {/* Courses */}
//         <h5 className="section-title mt-4">Course and Membership</h5>
//         <div className="row g-3">
//           {[
//             "CIP Level 1",
//             "CIP Level 2",
//             "CIP Level 3",
//             "CP Level 1",
//             "CP Level 2",
//             "CCI Level 1",
//             "CCI Level 2",
//           ].map((course, idx) => (
//             <div className="col-md-3" key={idx}>
//               <div className="form-check">
//                 <input
//                   type="checkbox"
//                   name="courses"
//                   value={course}
//                   className="form-check-input"
//                   checked={form.courses.includes(course)}
//                   onChange={handleChange}
//                 />
//                 <label className="form-check-label">{course}</label>
//               </div>
//             </div>
//           ))}

//           {/* Membership */}
//           <div className="col-md-6 d-flex align-items-center">
//             <label className="me-3">Are you an NACE / AMPP Member?</label>
//             <div className="form-check me-3">
//               <input
//                 type="radio"
//                 name="isMember"
//                 value="Yes"
//                 className="form-check-input"
//                 checked={form.isMember === "Yes"}
//                 onChange={handleChange}
//               />
//               <label className="form-check-label">Yes</label>
//             </div>
//             <div className="form-check">
//               <input
//                 type="radio"
//                 name="isMember"
//                 value="No"
//                 className="form-check-input"
//                 checked={form.isMember === "No"}
//                 onChange={handleChange}
//               />
//               <label className="form-check-label">No</label>
//             </div>
//           </div>
//           <div className="col-md-6">
//             <input
//               type="text"
//               name="memberNumber"
//               placeholder="If yes, Write Member Number"
//               className="form-control"
//               onChange={handleChange}
//               value={form.memberNumber}
//             />
//           </div>
//         </div>

//         {/* Conditional Certificate */}
//         {needsPrevCert && (
//           <>
//             <h5 className="section-title mt-4">Previous Certification</h5>
//             <div className="row g-3">
//               <div className="col-md-6">
//                 <input
//                   type="text"
//                   name="prevCertNo"
//                   placeholder="Previous Level Certificate No"
//                   className="form-control"
//                   onChange={handleChange}
//                   value={form.prevCertNo}
//                 />
//               </div>
//               <div className="col-md-6">
//                 <input
//                   type="text"
//                   name="prevCertValidity"
//                   placeholder="Validity of Certification"
//                   className="form-control"
//                   onChange={handleChange}
//                   value={form.prevCertValidity}
//                 />
//               </div>
//             </div>
//           </>
//         )}

//         {/* Agreement */}
//         <div className="form-check mt-3">
//           <input
//             type="checkbox"
//             name="agreement"
//             className="form-check-input"
//             checked={form.agreement}
//             onChange={handleChange}
//           />
//           <label className="form-check-label">
//             Agreement to pay any increase in fees and forfeit
//             cancellation/postponement charges, as applicable.
//           </label>
//         </div>

//         {/* Submit */}
//         <div className="text-center mt-3">
//           <button type="submit" className="regprofile-btn border-0 px-5">
//             Register
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }
// Befour i am using this
import React, { useState, useEffect } from "react";
import "./RegForm.css";
import { useNavigate } from "react-router-dom";

export default function RegistrationForm() {
  const navigate = useNavigate();
  const [message, setMessage] = useState({ type: "", text: "" });

  const [form, setForm] = useState({
    uid: "",
    firstName: "",
    gender: "",
    company: "",
    department: "",
    addressType: "",
    fullAddress: "",
    city: "",
    mealsPreferred: "",
    postalCode: "",
    state: "",
    country: "",
    countryCode: "",
    gstNo: "",
    email: "",
    homePhone: "",
    workPhone: "",
    mobileNumber: "",
    isMember: "",
    memberNumber: "",
    agreement: false,
  });

  // Country List
  const countries = [
    { name: "Afghanistan", code: "+93" },
    { name: "Albania", code: "+355" },
    { name: "Algeria", code: "+213" },
    { name: "Andorra", code: "+376" },
    { name: "Angola", code: "+244" },
    { name: "Argentina", code: "+54" },
    { name: "Armenia", code: "+374" },
    { name: "Australia", code: "+61" },
    { name: "Austria", code: "+43" },
    { name: "Azerbaijan", code: "+994" },
    { name: "Bahamas", code: "+1-242" },
    { name: "Bahrain", code: "+973" },
    { name: "Bangladesh", code: "+880" },
    { name: "Belarus", code: "+375" },
    { name: "Belgium", code: "+32" },
    { name: "Belize", code: "+501" },
    { name: "Benin", code: "+229" },
    { name: "Bhutan", code: "+975" },
    { name: "Bolivia", code: "+591" },
    { name: "Bosnia and Herzegovina", code: "+387" },
    { name: "Botswana", code: "+267" },
    { name: "Brazil", code: "+55" },
    { name: "Brunei", code: "+673" },
    { name: "Bulgaria", code: "+359" },
    { name: "Cambodia", code: "+855" },
    { name: "Cameroon", code: "+237" },
    { name: "Canada", code: "+1" },
    { name: "Chile", code: "+56" },
    { name: "China", code: "+86" },
    { name: "Colombia", code: "+57" },
    { name: "Costa Rica", code: "+506" },
    { name: "Croatia", code: "+385" },
    { name: "Cuba", code: "+53" },
    { name: "Cyprus", code: "+357" },
    { name: "Czech Republic", code: "+420" },
    { name: "Denmark", code: "+45" },
    { name: "Egypt", code: "+20" },
    { name: "Estonia", code: "+372" },
    { name: "Ethiopia", code: "+251" },
    { name: "Finland", code: "+358" },
    { name: "France", code: "+33" },
    { name: "Germany", code: "+49" },
    { name: "Greece", code: "+30" },
    { name: "Hong Kong", code: "+852" },
    { name: "Hungary", code: "+36" },
    { name: "Iceland", code: "+354" },
    { name: "India", code: "+91" },
    { name: "Indonesia", code: "+62" },
    { name: "Iran", code: "+98" },
    { name: "Iraq", code: "+964" },
    { name: "Ireland", code: "+353" },
    { name: "Israel", code: "+972" },
    { name: "Italy", code: "+39" },
    { name: "Japan", code: "+81" },
    { name: "Jordan", code: "+962" },
    { name: "Kazakhstan", code: "+7" },
    { name: "Kenya", code: "+254" },
    { name: "Kuwait", code: "+965" },
    { name: "Kyrgyzstan", code: "+996" },
    { name: "Laos", code: "+856" },
    { name: "Latvia", code: "+371" },
    { name: "Lebanon", code: "+961" },
    { name: "Libya", code: "+218" },
    { name: "Lithuania", code: "+370" },
    { name: "Luxembourg", code: "+352" },
    { name: "Malaysia", code: "+60" },
    { name: "Maldives", code: "+960" },
    { name: "Mali", code: "+223" },
    { name: "Malta", code: "+356" },
    { name: "Mexico", code: "+52" },
    { name: "Moldova", code: "+373" },
    { name: "Monaco", code: "+377" },
    { name: "Mongolia", code: "+976" },
    { name: "Morocco", code: "+212" },
    { name: "Myanmar", code: "+95" },
    { name: "Nepal", code: "+977" },
    { name: "Netherlands", code: "+31" },
    { name: "New Zealand", code: "+64" },
    { name: "Nigeria", code: "+234" },
    { name: "North Korea", code: "+850" },
    { name: "Norway", code: "+47" },
    { name: "Oman", code: "+968" },
    { name: "Pakistan", code: "+92" },
    { name: "Panama", code: "+507" },
    { name: "Peru", code: "+51" },
    { name: "Philippines", code: "+63" },
    { name: "Poland", code: "+48" },
    { name: "Portugal", code: "+351" },
    { name: "Qatar", code: "+974" },
    { name: "Romania", code: "+40" },
    { name: "Russia", code: "+7" },
    { name: "Saudi Arabia", code: "+966" },
    { name: "Serbia", code: "+381" },
    { name: "Singapore", code: "+65" },
    { name: "Slovakia", code: "+421" },
    { name: "Slovenia", code: "+386" },
    { name: "South Africa", code: "+27" },
    { name: "South Korea", code: "+82" },
    { name: "Spain", code: "+34" },
    { name: "Sri Lanka", code: "+94" },
    { name: "Sudan", code: "+249" },
    { name: "Sweden", code: "+46" },
    { name: "Switzerland", code: "+41" },
    { name: "Syria", code: "+963" },
    { name: "Taiwan", code: "+886" },
    { name: "Tanzania", code: "+255" },
    { name: "Thailand", code: "+66" },
    { name: "Turkey", code: "+90" },
    { name: "Uganda", code: "+256" },
    { name: "Ukraine", code: "+380" },
    { name: "United Arab Emirates", code: "+971" },
    { name: "United Kingdom", code: "+44" },
    { name: "United States", code: "+1" },
    { name: "Uruguay", code: "+598" },
    { name: "Uzbekistan", code: "+998" },
    { name: "Venezuela", code: "+58" },
    { name: "Vietnam", code: "+84" },
    { name: "Yemen", code: "+967" },
    { name: "Zambia", code: "+260" },
    { name: "Zimbabwe", code: "+263" },
  ];
  // Pre-fill from localStorage
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setForm((prev) => ({
        ...prev,
        uid: user.uid || "",
        firstName: user.fname || user.displayName || "",
        email: user.email || "",
        mobileNumber: user.cNumber || "",
      }));
    }
  }, []);

  // Handle field changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setForm((prev) => ({ ...prev, [name]: checked }));
    } else if (name === "country") {
      const selectedCountry = countries.find((c) => c.name === value);
      let newMobile = form.mobileNumber;

      // Remove ALL known country codes at the start
      countries.forEach((c) => {
        if (newMobile.startsWith(c.code)) {
          newMobile = newMobile.replace(c.code, "").trim();
        }
      });

      // Also remove any duplicate country codes like "+91+91"
      newMobile = newMobile.replace(/^\+?\d+\s*\+?\d*/, "").trim();

      // Add the new selected country code
      if (selectedCountry) {
        newMobile = `${selectedCountry.code} ${newMobile}`;
      }

      setForm((prev) => ({
        ...prev,
        country: value,
        countryCode: selectedCountry ? selectedCountry.code : "",
        mobileNumber: newMobile,
      }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalForm = {
      ...form,
      isMember: form.isMember ? form.isMember.toLowerCase() : "no",
    };

    // Required validation
    if (
      !finalForm.firstName.trim() ||
      !finalForm.fullAddress.trim() ||
      !finalForm.postalCode.trim() ||
      !finalForm.mobileNumber.trim() ||
      !finalForm.state.trim() ||
      !finalForm.country.trim() ||
      !finalForm.city.trim() ||
      !finalForm.email.trim()
    ) {
      setMessage({
        type: "error",
        text: "❌ Please fill all required fields.",
      });
      return;
    }

    // Normalize
    const normalizedForm = {
      ...finalForm,
      email: finalForm.email.toLowerCase().trim(),
      country: finalForm.country.toLowerCase().trim(),
      state: finalForm.state.toLowerCase().trim(),
      city: finalForm.city.toLowerCase().trim(),
    };

    try {
      const res = await fetch("https://agepcoatings.com/registerprofile", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(normalizedForm),
      });
      const data = await res.json();

      if (data.success) {
        setMessage({
          type: "success",
          text: "✅ Profile updated successfully!",
        });
        setTimeout(() => navigate("/profile"), 1000);
      } else {
        setMessage({
          type: "error",
          text: data.message || "❌ Already registered.",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setMessage({ type: "error", text: "❌ Server error, please try again." });
    }
  };

  return (
    <div className="container form-container mb-5">
      <h2 className="text-center mb-4">Complete Your Profile</h2>

      {message.text && (
        <div
          className={`alert ${
            message.type === "success" ? "alert-success" : "alert-danger"
          }`}
          role="alert"
        >
          {message.text}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {/* =================== Personal Details =================== */}
        <h5 className="section-title">Personal Details</h5>
        <div className="row g-3">
          <div className="col-md-6">
            <input
              type="text"
              name="firstName"
              placeholder="First Name *"
              className="form-control"
              onChange={handleChange}
              value={form.firstName}
              required
            />
          </div>

          <div className="col-md-6">
            <input
              type="text"
              name="company"
              placeholder="Company"
              className="form-control"
              onChange={handleChange}
              value={form.company}
            />
          </div>

          <div className="col-md-6">
            <input
              type="text"
              name="fullAddress"
              placeholder="Full Address *"
              className="form-control"
              onChange={handleChange}
              value={form.fullAddress}
              required
            />
          </div>

          <div className="col-md-6 d-flex align-items-center">
            <label className="me-3">Address:</label>
            <div className="form-check me-3">
              <input
                className="form-check-input"
                type="radio"
                name="addressType"
                value="Office"
                checked={form.addressType === "Office"}
                onChange={handleChange}
              />
              <label className="form-check-label">Office</label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="addressType"
                value="Residence"
                checked={form.addressType === "Residence"}
                onChange={handleChange}
              />
              <label className="form-check-label">Residence</label>
            </div>
          </div>

          <div className="col-md-6">
            <input
              type="text"
              name="department"
              placeholder="Department"
              className="form-control"
              onChange={handleChange}
              value={form.department}
            />
          </div>

          <div className="col-md-6">
            <input
              type="text"
              name="city"
              placeholder="City *"
              className="form-control"
              onChange={handleChange}
              value={form.city}
              required
            />
          </div>

          <div className="col-md-4">
            <input
              type="text"
              name="postalCode"
              placeholder="Postal Code *"
              className="form-control"
              onChange={handleChange}
              value={form.postalCode}
              required
            />
          </div>

          <div className="col-md-4">
            <input
              type="text"
              name="state"
              placeholder="State *"
              className="form-control"
              onChange={handleChange}
              value={form.state}
              required
            />
          </div>

          <div className="col-md-4">
            <select
              name="country"
              className="form-control"
              onChange={handleChange}
              value={form.country}
              required
            >
              <option value="">Select Country *</option>
              {countries.map((c, i) => (
                <option key={i} value={c.name}>
                  {c.name} ({c.code})
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-6">
            <input
              type="text"
              name="mobileNumber"
              placeholder="Mobile Number *"
              className="form-control"
              onChange={handleChange}
              value={form.mobileNumber}
              required
            />
          </div>

          <div className="col-md-6 d-flex align-items-center">
            <label className="me-3">Gender:</label>
            <div className="form-check me-3">
              <input
                className="form-check-input"
                type="radio"
                name="gender"
                value="Male"
                checked={form.gender === "Male"}
                onChange={handleChange}
              />
              <label className="form-check-label">Male</label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="gender"
                value="Female"
                checked={form.gender === "Female"}
                onChange={handleChange}
              />
              <label className="form-check-label">Female</label>
            </div>
          </div>

          <div className="col-md-6">
            <input
              type="text"
              name="gstNo"
              placeholder="GST No"
              className="form-control"
              onChange={handleChange}
              value={form.gstNo}
            />
          </div>

          <div className="col-md-6 d-flex align-items-center">
            <label className="me-4">Meals Preferred:</label>
            <div className="form-check me-3">
              <input
                className="form-check-input"
                type="radio"
                name="mealsPreferred"
                value="Veg"
                checked={form.mealsPreferred === "Veg"}
                onChange={handleChange}
              />
              <label className="form-check-label">Veg</label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="mealsPreferred"
                value="Non-Veg"
                checked={form.mealsPreferred === "Non-Veg"}
                onChange={handleChange}
              />
              <label className="form-check-label">Non-Veg</label>
            </div>
          </div>
        </div>

        {/* =================== Contact Details =================== */}
        <h5 className="section-title mt-4">Contact Details</h5>
        <div className="row g-3">
          <div className="col-md-6">
            <input
              type="email"
              name="email"
              placeholder="Email ID *"
              className="form-control"
              onChange={handleChange}
              value={form.email}
              required
            />
          </div>
          <div className="col-md-6">
            <input
              type="text"
              name="homePhone"
              placeholder="Home Phone"
              className="form-control"
              onChange={handleChange}
              value={form.homePhone}
            />
          </div>
          <div className="col-md-6">
            <input
              type="text"
              name="workPhone"
              placeholder="Work Phone"
              className="form-control"
              onChange={handleChange}
              value={form.workPhone}
            />
          </div>
        </div>

        {/* =================== Membership =================== */}
        <div className="row g-3 mt-4 align-items-center">
          <div className="col-md-6 d-flex align-items-center">
            <label className="me-2 mb-0">
              Are you an NACE / AMPP Member?{" "}
              <span className="text-danger">*</span>
            </label>
            <select
              name="isMember"
              className="form-select"
              value={form.isMember || "No"}
              onChange={handleChange}
              required
              style={{ width: "130px" }}
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>

          <div className="col-md-4">
            <input
              type="text"
              name="memberNumber"
              placeholder="If yes, Write Member Number"
              className="form-control"
              onChange={handleChange}
              value={form.memberNumber}
            />
          </div>
        </div>

        {/* =================== Agreement =================== */}
        <div className="form-check mt-3">
          <input
            type="checkbox"
            name="agreement"
            className="form-check-input"
            checked={form.agreement}
            onChange={handleChange}
          />
          <label className="form-check-label">
            Agreement to pay any increase in fees and forfeit
            cancellation/postponement charges, as applicable.
          </label>
        </div>

        <div className="text-center mt-3">
          <button type="submit" className="regprofile-btn border-0 px-5">
            Register
          </button>
        </div>
      </form>
    </div>
  );
}
